/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ─── Styles ───────────────────────────────────────────────────────────────
  var _style = document.createElement('style');
  _style.textContent =
    /* Stars */
    '.product-item__stars-row{display:flex;align-items:center;gap:2px;margin:4px 0 6px;flex-wrap:nowrap}' +
    '.product-item__stars-row .star{font-size:14px;line-height:1;color:#d8d8d8}' +
    '.product-item__stars-row .star--full{color:#f5a623}' +
    '.product-item__review-count{font-size:11px;color:var(--text-light,#888);margin-left:3px;white-space:nowrap}' +
    '';
  document.head.appendChild(_style);


  // ─── FIX: Deduplicate concurrent /cart/add network requests ───────────────
  //
  // Root cause: Broadcast's CartDrawer and the Corner Cart app both independently
  // call fetch('/cart/add') when the ATC button is clicked. Each adds qty=1,
  // so the cart ends up with qty=2.
  //
  // Solution: intercept window.fetch. Allow the FIRST /cart/add call through.
  // Any duplicate call within 1.5s returns a synthetic response.

  var _origFetch = window.fetch;
  var _cartAddInFlight = null;

  function trackCartAdd(realFetchPromise) {
    _cartAddInFlight = realFetchPromise.then(function(response) {
      return response.clone().json().then(function(data) {
        return { data: data, httpStatus: response.status };
      }).catch(function() {
        return { data: {}, httpStatus: response.status };
      });
    });
    setTimeout(function() { _cartAddInFlight = null; }, 1500);
    return realFetchPromise;
  }

  window.fetch = function(resource, options) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    var isCartAdd = /\/cart\/add/.test(url) && options && options.method === 'POST';

    if (isCartAdd) {
      if (_cartAddInFlight) {
        return _cartAddInFlight.then(function(cached) {
          return new Response(JSON.stringify(cached.data), {
            status: cached.httpStatus,
            headers: new Headers({ 'Content-Type': 'application/json' })
          });
        });
      }
      return trackCartAdd(_origFetch.apply(this, arguments));
    }

    return _origFetch.apply(this, arguments);
  };




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
